/*
 * Copyright (c) 2014-2023 Comparatio
 */

import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {versionInfo} from '../../../version-info';
import {Subscription} from 'rxjs/Subscription';
import {NgForm} from '@angular/forms';
import {PasswordResetService} from '../password-reset.service';
import {AuthService} from '../../auth.service';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ToastrService} from 'ngx-toastr';
import {ScreenSizeService} from '../../../services/screen-size.service';

@Component({
    selector: 'app-request-password-reset',
    templateUrl: './request-password-reset.component.html',
    styleUrls: ['../password-reset.component.scss'],
    providers: [
        PasswordResetService
    ]
})
export class RequestPasswordResetComponent implements OnInit, OnDestroy {

    public loading: boolean;
    public companyLogo: string;
    public companyName: string
    public versionLabel: string;
    public errors: Array<any>;
    public message: string;
    public isMobileScreen: boolean;
    private screenSizeService: ScreenSizeService;

    private subscriptions: Array<Subscription>;
    private passwordResetServiceRef = PasswordResetService;

    constructor(
        private passwordResetService: PasswordResetService,
        private authService: AuthService,
        private router: Router,
        private toast: ToastrService,
        private title: Title
    ) {
        this.title.setTitle(this.companyName + ' Portal - Forgot Password');
    }

    ngOnInit() {
        this.screenSizeService = ScreenSizeService.getInstance();
        this.isMobileScreen = this.screenSizeService.isMobileScreen;

        if (environment.production) {
            this.versionLabel = versionInfo.number;
        } else {
            this.versionLabel = 'Test - ' + versionInfo.number;
        }

        if ( this.authService.isAuthenticated ) {
            this.router.navigate(['dashboard']);
        }

        this.subscriptions = [];
        this.loading = false;
        this.companyLogo = this.passwordResetServiceRef.DEFAULT_COMPANY_LOGO;
        this.companyName = this.passwordResetServiceRef.DEFAULT_COMPANY_NAME;
        this.message = '';
        this.errors = [];

        this.subscriptions.push(this.authService.getLogo().subscribe(result => {
            this.companyLogo = result.logo;
            this.companyName = result.name;
            this.title.setTitle(this.companyName + ' Portal - Forgot Password');
        }));
    }

    ngOnDestroy() {
        if (this.subscriptions.length > 0) {
            for (let index = 0; index < this.subscriptions.length; index++) {
                this.subscriptions[index].unsubscribe();
            }
        }
    }

    onSubmit(form: NgForm) {
        this.loading = true;
        const data = {
            username: form.value.username
        };
        this.errors = [];
        this.passwordResetService.requestPasswordReset(data).subscribe(result => {
            if (result.success) {
                this.message = 'An email containing a password reset link has been sent.';
            } else {
                this.errors = result.errors;
            }
            this.loading = false;
        }, () => {
            this.loading = false;
            this.toast.error('Request timed out.', 'Service Error');
        });
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/auth/password-reset/request-password-reset/request-password-reset.component.ts